import appConst from "../constents/app.const";
import React from "react";
import moment from "moment";
export const setCookieData = (data) => {
  let encryptedData = encrypt(data);
  setCookie("internalTokenDataBckEn", encryptedData, 2);
};

export const getCookieData = () => {
  return decrypt(getCookie("internalTokenDataBckEn"));
};

function setCookie(cname, cvalue, hours) {
  var d = new Date();
  d.setFullYear(d.getFullYear() + hours);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const EditPageIcon = ()=>{
  return <svg style={{height:"16px",width:"16px"}} id="Capa_1" enable-background="new 0 0 512 512" height="20" viewBox="0 0 512 225" width="20" xmlns="http://www.w3.org/2000/svg"><g><path d="m493.264 411.668c12.082-12.083 18.736-28.147 18.736-45.235v-40.48c0-22.611-18.396-41.006-41.006-41.006h-36.893c-1.373 0-2.489-1.113-2.489-2.481l-.001-42.403h2.958c20.204 0 36.642-16.437 36.642-36.641v-72.639c0-20.204-16.438-36.641-36.642-36.641h-101.451c0-11.901 0-42.978 0-51.261 0-22.023-17.913-40.246-40.246-40.246h-252.626c-22.191-.001-40.246 18.053-40.246 40.245v203.519c0 22.191 18.055 40.246 40.246 40.246h252.627c22.191 0 40.245-18.054 40.245-40.246v-6.336h40.151l-.001 51.948h-4.163c-19.64 0-35.617 15.978-35.617 35.618 1.321 14.233-4.79 34.47 11.831 54.438l27.033 32.473c7.143 8.58 4.538 17.292 5.096 23.238-8.301 3.582-14.127 11.844-14.127 21.444v40.146c0 5.523 4.478 10 10 10h115.898c5.522 0 10-4.477 10-10v-40.148c0-10.111-6.463-18.738-15.473-21.975v-6.774c0-11.715 8.315-17.184 9.518-18.803zm-42.053-280.886v72.639c0 9.176-7.466 16.641-16.642 16.641h-2.967c-.363-14.92-12.074-27.384-27.194-28.39-16.545-1.131-30.74 11.846-31.13 28.39-38.143 0-38.821 0-63.638 0-9.176 0-16.641-7.465-16.641-16.641v-72.639c0-9.176 7.465-16.641 16.641-16.641h124.929c9.176 0 16.642 7.465 16.642 16.641zm-138.093 115.617c0 11.164-9.082 20.246-20.245 20.246h-252.627c-11.164 0-20.246-9.082-20.246-20.246v-162.516h14c5.522 0 10-4.477 10-10s-4.478-10-10-10h-14c.035-22.003-.079-21.267.105-23.071 1.039-10.196 9.675-18.178 20.141-18.178h252.627c11.177 0 20.245 9.099 20.245 20.246v21.003h-199.118c-5.522 0-10 4.477-10 10s4.478 10 10 10h199.118v10.258h-3.478c-20.204 0-36.641 16.437-36.641 36.641v72.639c0 20.204 16.437 36.641 36.641 36.641h3.478zm47.571 122.871c-4.645-5.579-7.202-12.65-7.202-19.91v-21.732c0-8.612 7.006-15.618 15.617-15.618h4.164v25.714c0 5.523 4.478 10 10 10s10-4.477 10-10c.001-84.411-.001-34.203.001-116.959 0-12.18 18.342-12.092 18.342-.003 0 15.853.001 46.165.001 61.704 0 12.396 10.089 22.481 22.489 22.481h36.893c11.583 0 21.006 9.423 21.006 21.006v40.48c0 21.768-14.712 32.468-15.83 34.043-15.053 15.053-12.034 32.98-12.424 35.399h-66.299c-.456-3.513 2.626-19.299-9.726-34.133zm118.53 120.096h-95.899v-30.146c0-1.844 1.5-3.344 3.345-3.344h89.209c1.845 0 3.345 1.5 3.345 3.344z"/><path d="m255.545 152.154h-15.253v-15.253c0-5.523-4.478-10-10-10s-10 4.477-10 10v15.253h-15.253c-5.522 0-10 4.477-10 10s4.478 10 10 10h15.253v15.253c0 5.523 4.478 10 10 10s10-4.477 10-10v-15.253h15.253c5.522 0 10-4.477 10-10s-4.478-10-10-10z"/><path d="m128.08 152.154h-15.254v-15.253c0-5.523-4.478-10-10-10s-10 4.477-10 10v15.253h-15.253c-5.522 0-10 4.477-10 10s4.478 10 10 10h15.253v15.253c0 5.523 4.478 10 10 10s10-4.477 10-10v-15.253h15.254c5.522 0 10-4.477 10-10s-4.477-10-10-10z"/><path d="m272.333 52.91h16c5.522 0 10-4.477 10-10s-4.478-10-10-10h-16c-5.522 0-10 4.477-10 10s4.478 10 10 10z"/><path d="m84.025 73.883c0-5.523-4.478-10-10-10h-.025c-5.522 0-9.987 4.477-9.987 10s4.49 10 10.013 10 9.999-4.477 9.999-10z"/><path d="m352.975 177.102h9.131v9.13c0 5.523 4.478 10 10 10s10-4.477 10-10v-9.13h9.13c5.522 0 10-4.477 10-10s-4.478-10-10-10h-9.13v-9.13c0-5.523-4.478-10-10-10s-10 4.477-10 10v9.13h-9.131c-5.522 0-10 4.477-10 10s4.477 10 10 10z"/></g></svg>
}

const crypter = (salt) => {
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
  const applySaltToChar = (code) =>
    textToChars(salt).reduce((a, b) => a ^ b, code);

  return (text) =>
    text.split("").map(textToChars).map(applySaltToChar).map(byteHex).join("");
};

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const decrypter = (salt) => {
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const applySaltToChar = (code) =>
    textToChars(salt).reduce((a, b) => a ^ b, code);
  return (encoded) =>
    encoded
      .match(/.{1,2}/g)
      ?.map((hex) => parseInt(hex, 16))
      ?.map(applySaltToChar)
      ?.map((charCode) => String.fromCharCode(charCode))
      ?.join("");
};

const encrypt = (data) => {
  const crypterObj = crypter(appConst.encryptionSalt);
  return crypterObj(data);
};
const decrypt = (data) => {
  const decrypterObj = decrypter(appConst.encryptionSalt);
  return decrypterObj(data);
};

export function deleteAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}
export const filterTypeOption = [
  { label: "Post", value: "post" },
  { label: "Category", value: "category" },
  { label: "Tag", value: "tag" },
  { label: "Topic", value: "topic" },
  { label: "Parent Category", value: "parent_category" },
];
export const orderByOption = [
  { label: "Asc", value: "asc" },
  { label: "Desc", value: "desc" },
];
export const orderTypeOptions = [
  { label: "Title", value: "title" },
  { label: "Date", value: "created_at" },
  { label: "Publish Date", value: "publish_at" },
];
export const paginationTypeOptions = [
  // { label: "Ajax Load", value: "ajax-load" },
  // { label: "Pagination", value: "pagination" },
  { label: "None", value: "default" },
];
 export const shulderTypes = [
  { label: "Category", value: "category" },
  { label: "Single-Tag", value: "single-tag" },
];

export const filterTypeHorizontalListBlock = [
  { label: "Standard", value: "standard" },
  { label: "Videos", value: "video" },
  { label: "Audio", value: "audio" },
  { label: "Gallery", value: "gallery" },
];


// var queryParams = new URLSearchParams(window.location.search);
//             queryParams.set("q",searchVal);
//             window.history.replaceState(null, null, "?"+queryParams.toString());

export const changeUrlSearchParams = (obj = {},history=null,exeptKeys = [])=>{
  var queryParams = new URLSearchParams(window.location.search);
  Object.keys(obj).forEach(key=>{
    if(!exeptKeys.includes(key)){
      queryParams.set(key,obj[key]);
    }
    
  })
  if(history){
    history.push({
      pathname: window.location.pathname,
      search: '?'+queryParams.toString(),
    })
  }else{
    window.history.replaceState(null, null, "?"+queryParams.toString());
  }
  
}

export const getAllUrlSearchParams = (onlyKey=false)=>{
  let url = new URL(window.location.href)
  let search = decodeURIComponent(window.location.search), query = {}
  search =search.replace("?","");
  let tempArr = search.split("&")
  tempArr.forEach(d=>{
    let singleOb = d.split("=")
    query[singleOb[0]]=singleOb[1]?singleOb[1]:''
  })

  if(onlyKey){
    return Object.keys(query)
  }
  return query
}

export const deleteAllSearchQuery = (exeptKeys = [])=>{
  let url = new URL(window.location.href);
  let params = new URLSearchParams(url.search);

  getAllUrlSearchParams(true).forEach(key=>{
   
    if(!exeptKeys.includes(key)){ params.delete(key); }
  })

  window.history.replaceState(null, null, "?"+params.toString());
}

export const gmtToLocalTimeFormating = (date)=>{
  return date?moment(date).local().format("dddd MMM DD YYYY h:mm A"):""
}